const MainSearch = class extends HTMLElement {
    constructor() {
        super(), this.querySelectorAll(".main-search__close").forEach(el => {
            el.addEventListener("click", evt => {
                evt.preventDefault(), document.body.classList.remove("show-search")
            })
        }), this.querySelector(".main-search__input").addEventListener("keyup", evt => {
            evt.key === "Escape" && this.querySelector(".main-search__close").dispatchEvent(new Event("click"))
        }), this.dataset.quickSearch === "true" && this.initQuickSearch()
    }
    initQuickSearch() {
        
    }
};
window.customElements.define("main-search", MainSearch);